// extracted by mini-css-extract-plugin
export default {"container":"PrivateRoutes_container__yuIJo","heroFoot":"PrivateRoutes_heroFoot__AZqcK"};